
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class ViewCard extends Vue {
    // Properties
    @Prop(String) readonly view!: string;
    @Prop(String) readonly mode!: string;
    @Prop(Array) readonly customerIds!: string[];

    local = {
        queryParameters: '',
    };

    async goToView() {
        await this.$router.push({
            name: `${this.view}`,
            params: {
                customerId: this.customerIds ? this.customerIds.join(',') : '',
            },
        });
    }
}
